import {Component} from "@angular/core";
import {RouterOutlet} from "@angular/router";
import {BreadcrumbComponent} from "@lib/base/components/navigation/breadcrumb/breadcrumb.component";
import {NavigationMenuComponent} from "@lib/base/components/navigation/navigation-menu/navigation-menu.component";
import {SidebarComponent} from "@lib/base/components/navigation/sidebar/sidebar.component";
import {SidenavComponent} from "@lib/base/components/navigation/sidenav/sidenav.component";
import {APP_NAVIGATION} from "@pages/app.navigation";
import {ADMIN_NAVIGATION} from "./administration-sidebar-definition";
import {AlertsMenuComponent} from "@custom/base/components/alerts/alerts/alerts-menu.component";

@Component({
    selector: "app-admin-home",
    imports: [
        SidebarComponent,
        RouterOutlet,
        SidenavComponent,
        BreadcrumbComponent,
        NavigationMenuComponent,
        AlertsMenuComponent,
    ],
    templateUrl: "./administration-home.component.html",
    styleUrl: "./administration-home.component.scss",
})
export class AdministrationHomeComponent {
    protected navigationData = ADMIN_NAVIGATION;
    protected readonly APP_NAVIGATION = APP_NAVIGATION;

}
